import { SHOPIFY_STORE_DOMAIN } from '@portal/config/base';
import { storeCodeSchema } from '@portal/schema/storeCode';
import Script from 'next/script';
import { useStoreValue } from 'state/hooks/useStore';

const SuperfiliateScript = () => {
  const store = useStoreValue();

  // Only load Superfiliate for US store to avoid 404s in other regions
  if (store !== storeCodeSchema.enum.us) {
    return null;
  }

  const shopifyDomain = SHOPIFY_STORE_DOMAIN[store];
  return (
    <Script
      src={`https://superfiliate-cdn.com/storefront.js?shop=${shopifyDomain}`}
      strategy="afterInteractive"
    />
  );
};

export default SuperfiliateScript;
